import { put, all, select } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import selectors from "rdx/selectors";
import messages from "rdx/modules/projects/messages";
import { camelizeKeys } from "lib/helpers";
import SchemaValidator from "util/schema-helpers/SchemaValidator";
import FEATURE_FLAGS from "../../../../util/featureFlags";
import { ProjectContractsResponse } from "../schemas/contracts";

function* getContractDetails({ payload }: { payload: { providerLeadId: number | string } }) {
  const { providerLeadId } = payload;

  const currentContractDetails = yield select(selectors.getContractDetails);
  if (
    currentContractDetails?.providerLeadId &&
    Number(currentContractDetails.providerLeadId) !== Number(providerLeadId)
  ) {
    yield put(actions.resetContractDetails());
  }

  const { data, error } = yield* makeRequest.get(`/change_orders/${providerLeadId}/contracts`);

  const result = SchemaValidator.validate<typeof ProjectContractsResponse>({
    schema: ProjectContractsResponse,
    schemaName: "ProjectContractsResponse",
    dto: camelizeKeys(data),
  });

  if (error && error.status !== 204) {
    yield put(actions.resetContractDetails());
    yield put(actions.setContractTabVisible(false));
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_CONTRACT_DETAILS,
    });
  }

  if (!result.success || !result.data?.body) {
    yield put(actions.resetContractDetails());
    yield put(actions.setContractTabVisible(false));
    return null;
  }

  if (result.success && result.data.body.contracts.length > 0) {
    if (FEATURE_FLAGS.includes("changeOrder")) {
      yield all([
        put(actions.setContractDetails({ ...result.data.body, providerLeadId: Number(providerLeadId) })),
        put(actions.setContractTabVisible(!!result.data.body.contracts)),
      ]);
    }
    if (!FEATURE_FLAGS.includes("changeOrder")) {
      yield all([
        put(actions.setContractDetails({ ...result.data.body, providerLeadId: Number(providerLeadId) })),
        put(actions.setContractTabVisible(true)),
      ]);
    }
    if (
      result.data.body.pendingDesignChange &&
      result.data.body.salesConsultantInformed &&
      result.data.body.changeOrder
    ) {
      yield put(actions.setProjectChangeRequestVisible(true));
    }
  }

  return null;
}

export default getContractDetails;
